if (window.__POWERED_BY_SYDONE__) {
    // eslint-disable-next-line no-undef
    __webpack_public_path__ = window.__INJECTED_PUBLIC_PATH_BY_SYDONE__;
  }